import styled from 'styled-components/macro';

export const LineChartWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  font-family: Inter;
  padding: 16px;
  border-radius: 8px;
  cursor: auto;
  isolation: isolate;
`;
